import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const PersonIcon = ({
  color, fillOpacity, ...props
}) => (
  <svg
    {...helpers.getSvgDimensionsProps(props)}
    {...props}
  >
    <path
      fill={color}
      d="M14.7679 12.9141C14.3995 12.0414 13.8648 11.2486 13.1937 10.5801C12.5246 9.90959 11.7321 9.37501 10.8597 9.00586C10.8519 9.00195 10.8441 9 10.8363 8.99609C12.0531 8.11719 12.8441 6.68555 12.8441 5.07031C12.8441 2.39453 10.6761 0.226562 8.00036 0.226562C5.32457 0.226562 3.1566 2.39453 3.1566 5.07031C3.1566 6.68555 3.94762 8.11719 5.16442 8.99805C5.1566 9.00195 5.14879 9.00391 5.14098 9.00781C4.26598 9.37695 3.48082 9.90625 2.807 10.582C2.13651 11.2511 1.60193 12.0437 1.23278 12.916C0.870124 13.77 0.674537 14.6856 0.656604 15.6133C0.656083 15.6341 0.659739 15.6549 0.667358 15.6743C0.674976 15.6937 0.686403 15.7114 0.700964 15.7263C0.715526 15.7412 0.732927 15.7531 0.752143 15.7612C0.77136 15.7693 0.792002 15.7734 0.812854 15.7734H1.98473C2.07067 15.7734 2.13903 15.7051 2.14098 15.6211C2.18004 14.1133 2.78551 12.7012 3.85582 11.6309C4.96325 10.5234 6.43395 9.91406 8.00036 9.91406C9.56676 9.91406 11.0375 10.5234 12.1449 11.6309C13.2152 12.7012 13.8207 14.1133 13.8597 15.6211C13.8617 15.707 13.93 15.7734 14.016 15.7734H15.1879C15.2087 15.7734 15.2294 15.7693 15.2486 15.7612C15.2678 15.7531 15.2852 15.7412 15.2997 15.7263C15.3143 15.7114 15.3257 15.6937 15.3334 15.6743C15.341 15.6549 15.3446 15.6341 15.3441 15.6133C15.3246 14.6797 15.1312 13.7715 14.7679 12.9141ZM8.00036 8.42969C7.10387 8.42969 6.26012 8.08008 5.62535 7.44531C4.99059 6.81055 4.64098 5.9668 4.64098 5.07031C4.64098 4.17383 4.99059 3.33008 5.62535 2.69531C6.26012 2.06055 7.10387 1.71094 8.00036 1.71094C8.89684 1.71094 9.74059 2.06055 10.3754 2.69531C11.0101 3.33008 11.3597 4.17383 11.3597 5.07031C11.3597 5.9668 11.0101 6.81055 10.3754 7.44531C9.74059 8.08008 8.89684 8.42969 8.00036 8.42969Z"
    />
  </svg>
);

PersonIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

PersonIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(16, 16),
  ...helpers.getViewBoxProperty({ width: 16, height: 16 }),
};

export default PersonIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/person.js